var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { ALL_SETTINGS, useAuthProvider, usePlugFilespaceClient, } from '@lucidlink/workspacemanagement';
import { FilespaceSettingsKeyFactory } from '../query-key-factories';
export const useGetGlobalSettings = ({ filespaceId, workspaceId, }) => {
    _react_refresh_temp_1();
    const { currentUser } = useAuthProvider();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const query = useQuery({
        queryKey: FilespaceSettingsKeyFactory.global(filespaceId),
        queryFn: async () => plugFilespaceClient({
            action: (fsClient) => fsClient.globalSettingManager().get(ALL_SETTINGS),
            filespaceId,
            workspaceId,
        }),
        networkMode: 'always',
        enabled: Boolean(currentUser?.emailVerified),
    });
    return { query };
};
_react_refresh_temp_1(useGetGlobalSettings, "jRMx3r7nIBDWbUBVlsDJFgWprew=", false, () => [useAuthProvider, usePlugFilespaceClient, useQuery]);
